document.addEventListener("swym:loaded", function () {
  if (window.SwymCallbacks) {
    SwymCallbacks.push(function () {
      if (window._swat) {
        _swat.initializeActionButtons(".swym-button");
      }
    });
  }
});


document.addEventListener("swym:loaded", function () {
  if (!window._swat) return;

  _swat.fetchWrtEventTypeET(
    _swat.EventTypes.addToWishlist,
    function (items) {
      updateWishlistCount(items.length);
    }
  );

  _swat.fetchWrtEventTypeET(
    _swat.EventTypes.removeFromWishlist,
    function (items) {
      updateWishlistCount(items.length);
    }
  );

  // Initial load
  _swat.fetch(function (data) {
    updateWishlistCount(data.length);
  });

  function updateWishlistCount(count) {
    const el = document.querySelector(".wishlist-count");
    if (!el) return;

    if (count > 0) {
      el.textContent = count;
      el.hidden = false;
    } else {
      el.hidden = true;
    }
  }
});
